import styled from 'styled-components';

export const ErrorMessageVia = styled('p')`
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 1.66;
  letter-spacing: 0.03333em;
  text-align: left;
  color: #d32f2f;
`;
